@if (!!selectedProfile) {
@for (price of prices; track price; let i = $index) {
@if (price.profileId === selectedProfile.id) {
<div class="flex flex-col" [ngClass]="isInHeader ? 'px-2' : 'gap-2 px-4'">
  @if(!isInHeader) {
  <mat-divider class="!border-[#E7EAEE]" />
  }
  <div class="flex w-full">
    <div class="flex flex-1 flex-col items-center justify-center gap-[0.125rem]">
      <span class="text-md" [ngClass]="[isInHeader ? 'text-white' : 'text-[#3D5979]']"
        class="font-normal">{{singleRideText}}</span>
      <span class="text-base font-normal" [ngClass]="{'text-[#8ABAFA]': isInHeader}">{{
        !!price.singleRidePrice ? formatPrice(price.singleRidePrice) : freeText
        }}
      </span>
    </div>
    <div class="w-px self-stretch bg-[#E7EAEE]" [ngClass]="{'bg-[#3D5979]': isInHeader}"></div>
    <div class="flex flex-1 flex-col items-center justify-center gap-[0.125rem]">
      <span class="text-md" [ngClass]="[isInHeader ? 'text-white' : 'text-[#3D5979]']"
        class="font-normal">{{dailyFreeText}}</span>
      <span class="text-base font-normal" [ngClass]="{'text-[#8ABAFA]': isInHeader}">{{
        !!price.dailyPrice ? formatPrice(price.dailyPrice) : freeText
        }}
      </span>
    </div>
    <div class="w-px self-stretch bg-[#E7EAEE]" [ngClass]="{'bg-[#3D5979]': isInHeader}"></div>
    <div class="flex flex-1 flex-col items-center justify-center gap-[0.125rem]">
      <span class="text-md" [ngClass]="[isInHeader ? 'text-white' : 'text-[#3D5979]']"
        class="font-normal">{{monthlyFreeText}}</span>
      <span class="text-base font-normal" [ngClass]="{'text-[#8ABAFA]': isInHeader}">{{
        !!price.monthlyPrice ? formatPrice(price.monthlyPrice) : freeText
        }}
      </span>
    </div>
  </div>
</div>
}
}
}